class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);    
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if (!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
      this.updatePriceDisplay();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if(document.querySelector('.media-thumb')){
      document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
        var mediaid = e.dataset.id;
        if(mediaid==fetured_id){
          new Swiper('.media-nav').slideTo(e.dataset.index,1000,false);
        }
      });
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if(checked_gender){
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if(option_count>=fieldlen){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    if(option_count>=fieldlen){
      document.querySelector('.choose-cart').classList.remove('hide-selectore-button');
      document.querySelector('.choose-selector').classList.add('hide-selectore-button');      
    }else{
      document.querySelector('.choose-cart').classList.add('hide-selectore-button');
      document.querySelector('.choose-selector').classList.remove('hide-selectore-button');
    }   
  }
  updatePriceDisplay() {
    if (!this.currentVariant) return;
    const priceElement = document.querySelector('.total-price-value');
    if (priceElement && this.currentVariant.price) {
      const unitPrice = this.currentVariant.price / 100;
      priceElement.setAttribute('data-unit-price', unitPrice);
      const qtyInput = document.querySelector('.qty-input');
      const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      updateTotalPrice(quantity);
    }
  }
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);

// Function to format price with currency
function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || '${{amount}}';

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number === null) {
      return '0';
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

// Function to update total price
function updateTotalPrice(quantity) {
  const priceElement = document.querySelector('.total-price-value');
  if (!priceElement) return;

  const unitPrice = parseFloat(priceElement.getAttribute('data-unit-price'));
  if (isNaN(unitPrice)) return;

  const totalPrice = unitPrice * quantity;
  const totalPriceInCents = Math.round(totalPrice * 100);
  
  // Get the currency format from Shopify theme settings
  const moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}';
  
  priceElement.textContent = formatMoney(totalPriceInCents, moneyFormat);
}

// Quantity Selector Functionality with Hidden Input Sync and Price Update
function initQuantitySelector() {
  const quantitySelectors = document.querySelectorAll('.quantity-selector');
  
  quantitySelectors.forEach(selector => {
    const minusBtn = selector.querySelector('.qty-minus');
    const plusBtn = selector.querySelector('.qty-plus');
    const input = selector.querySelector('.qty-input');
    
    // Find the hidden quantity input in the form
    const form = selector.closest('.snippet-addto-cart').querySelector('form');
    const hiddenQuantity = form ? form.querySelector('.hidden-quantity') : null;
    
    if (minusBtn && plusBtn && input) {
      // Remove any existing listeners by cloning
      const newMinusBtn = minusBtn.cloneNode(true);
      const newPlusBtn = plusBtn.cloneNode(true);
      minusBtn.parentNode.replaceChild(newMinusBtn, minusBtn);
      plusBtn.parentNode.replaceChild(newPlusBtn, plusBtn);
      
      // Function to sync hidden input, update price, and toggle minus button state
      const syncQuantity = (value) => {
        if (hiddenQuantity) {
          hiddenQuantity.value = value;
        }
        updateTotalPrice(value);
        
        // Toggle disabled class on minus button
        if (value <= 1) {
          newMinusBtn.classList.add('disabled');
          newMinusBtn.setAttribute('disabled', 'disabled');
        } else {
          newMinusBtn.classList.remove('disabled');
          newMinusBtn.removeAttribute('disabled');
        }
      };
      
      // Minus button click
      newMinusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        let currentValue = parseInt(input.value) || 1;
        if (currentValue > 1) {
          currentValue = currentValue - 1;
          input.value = currentValue;
          syncQuantity(currentValue);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      
      // Plus button click
      newPlusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        let currentValue = parseInt(input.value) || 1;
        currentValue = currentValue + 1;
        input.value = currentValue;
        syncQuantity(currentValue);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      
      // Input change validation and sync
      input.addEventListener('input', function() {
        let value = parseInt(this.value) || 1;
        if (value < 1) {
          value = 1;
          this.value = value;
        }
        syncQuantity(value);
      });
      
      input.addEventListener('blur', function() {
        let value = parseInt(this.value) || 1;
        if (this.value === '' || value < 1) {
          value = 1;
          this.value = value;
        }
        syncQuantity(value);
      });
      
      // Initialize hidden input and price with current value
      const initialValue = parseInt(input.value) || 1;
      syncQuantity(initialValue);
    }
  });
}

function variant_drodown(){
  if(document.querySelector('.dropdown-wrap')){
    document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
      dropdown.querySelector('.variant-dropdown').addEventListener('click',function(event){
        event.preventDefault();
        
        // Check if currently active
        const isActive = dropdown.classList.contains('active');
        
        // Close all dropdowns
        document.querySelectorAll('.dropdown-wrap').forEach(function(d){
          d.classList.remove('active');
        });
        
        // If it wasn't active, open it
        if (!isActive) {
          dropdown.classList.add('active');
        }
      });
      
      // Attach change event listener safely outside of click
      dropdown.querySelectorAll('input[type="radio"]').forEach(function(e){
        e.addEventListener('change',function(button){
          dropdown.classList.remove('active');
          dropdown.querySelector('.variant-dropdown').innerHTML = e.value;
        });
      });
    });

    // Close dropdowns if user clicks outside of them
    document.addEventListener('click', function(event) {
      if (!event.target.closest('.dropdown-wrap')) {
        document.querySelectorAll('.dropdown-wrap').forEach(function(d){
          d.classList.remove('active');
        });
      }
    });
  }
}

// Add to Cart functionality
const _productAddcartBtn = document.querySelector('.product-addcart');
if (_productAddcartBtn) _productAddcartBtn.addEventListener('click',function(evt){
  evt.preventDefault();
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  var cartform = document.querySelector('.product-addcart').closest('form');
  const formData = new FormData(cartform);  
  config.body = formData;
  fetch(`${routes.cart_add_url}`, config)
  .then((response) => response.json())
  .then((response) => {
    if (response.status) {
      document.querySelector('.product-form-error').innerHTML = response.description;
      setTimeout(function(e){
        document.querySelector('.product-form-error').innerHTML  = '';
      },2000);
      return;
    }else{
      if(typeof load_cart == 'function'){
        load_cart();
        setTimeout(function(e){
          document.querySelector('body').classList.add('open-drawer');
        },500);
      }else{
        window.location.href = "/cart";
      }
    }
  })
  .catch((e) => {
    console.error(e);
  })
  .finally(() => {

  });
});

// Buy Now functionality - NEW CODE
function initBuyNowButton() {
  const buyNowButtons = document.querySelectorAll('.buy-now-button');
  
  buyNowButtons.forEach(button => {
    // Remove any existing listeners by cloning
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);
    
    newButton.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Find the closest form
      const form = this.closest('.snippet-addto-cart').querySelector('form');
      if (!form) {
        console.error('Form not found');
        return;
      }
      
      // Get variant ID
      const variantIdInput = form.querySelector('input[name="id"]');
      const variantId = variantIdInput ? variantIdInput.value : null;
      
      // Get quantity from the visible input
      const qtyInput = document.querySelector('.qty-input');
      const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      
      if (!variantId) {
        // Show error if no variant selected
        const errorElement = document.querySelector('.product-form-error');
        if (errorElement) {
          errorElement.innerHTML = 'Please select a variant';
          setTimeout(function() {
            errorElement.innerHTML = '';
          }, 2000);
        }
        return;
      }
      
      // Disable button to prevent double clicks
      newButton.disabled = true;
      newButton.style.opacity = '0.6';
      
      // Prepare form data
      const formData = {
        items: [{
          id: variantId,
          quantity: quantity
        }]
      };
      
      // Add to cart and redirect to checkout
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(data => {
        if (data.status && data.status === 422) {
          // Handle error
          const errorElement = document.querySelector('.product-form-error');
          if (errorElement) {
            errorElement.innerHTML = data.description || 'Error adding to cart';
            setTimeout(function() {
              errorElement.innerHTML = '';
            }, 2000);
          }
          // Re-enable button
          newButton.disabled = false;
          newButton.style.opacity = '1';
        } else {
          // Success - redirect to checkout
          load_cart();
          window.location.href = '/checkout';
        }
      })
      .catch(error => {
        console.error('Error:', error);
        const errorElement = document.querySelector('.product-form-error');
        if (errorElement) {
          errorElement.innerHTML = 'There was an error. Please try again.';
          setTimeout(function() {
            errorElement.innerHTML = '';
          }, 2000);
        }
        // Re-enable button
        newButton.disabled = false;
        newButton.style.opacity = '1';
      });
    });
  });
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function initProductMediaSlider() {
  if (!document.querySelector('.product-media-gallery')) return;
  
  // Initialize thumbnail slider first
  const thumbnailSlider = new Swiper(".thumbnail-media-slider", {
    loop: false,
    spaceBetween: 20,
    slidesPerView: 5,
    direction: 'vertical',
    freeMode: false,
    mousewheel: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    // centeredSlides: false,
    // slidesPerGroup: 1,
    breakpoints: {
      0: {
        direction: 'horizontal',
        slidesPerView: 4,
      },
      768: {
        direction: 'vertical',
        slidesPerView: 5,
      }
    }
  });

  // Initialize main media slider
  const mainMediaSlider = new Swiper(".main-media-slider", {
    loop: false,
    spaceBetween: 10,
    navigation: {
      nextEl: ".slider-nav-next",
      prevEl: ".slider-nav-prev",
    },
    pagination: {
      el: ".slider-dots",
      clickable: true,
    },
    thumbs: {
      swiper: thumbnailSlider,
    },
  });

  // When main slider changes, scroll thumbnails smartly
  mainMediaSlider.on('slideChange', function() {
    const activeIndex = mainMediaSlider.activeIndex;
    const totalSlides = mainMediaSlider.slides.length;
    const visibleSlides = 5;
    
    // Calculate which thumbnail should be at the top
    if (activeIndex >= visibleSlides - 1) {
      // Scroll so the active slide is at the bottom of visible area
      thumbnailSlider.slideTo(activeIndex - visibleSlides + 1);
    } else {
      // Keep at the beginning
      thumbnailSlider.slideTo(0);
    }
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    // initProductMediaSlider();
    initQuantitySelector();
    initBuyNowButton(); // Initialize Buy Now button
  });
} else {
  // initProductMediaSlider();
  initQuantitySelector();
  initBuyNowButton(); // Initialize Buy Now button
}

// initProductMediaSlider();
initQuantitySelector();
initBuyNowButton(); // Initialize Buy Now button
variant_drodown();

document.addEventListener("shopify:section:load", function(event) {
  // initProductMediaSlider();
  initQuantitySelector();
  initBuyNowButton(); // Initialize Buy Now button on section reload
  variant_drodown();
});

function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}

function doScrolling(element, duration) {
  var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
  var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if (!diff) return
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}

if(document.querySelector('.choose-selector')){
  if (window.innerWidth < 641) {
    document.querySelector('.choose-selector a').addEventListener('click', doScrolling.bind(null, '#product-form-installment', 2000))
  }
}

const shareBtn = document.querySelector('#get-share');

if (shareBtn) shareBtn.addEventListener('click', async () => {
  try {
    const urlToCopy = window.location.href;
    await navigator.clipboard.writeText(urlToCopy);
    shareBtn.classList.add('copied');
    shareBtn.querySelector('p').textContent = 'Link Copied!';
    setTimeout(() => {
      shareBtn.classList.remove('copied');
      shareBtn.querySelector('p').textContent = shareBtn.dataset.text;
    }, 2000);

  } catch (err) {
    console.error('Failed to copy:', err);
  }
});

/* =============================================
   STICKY ADD-TO-CART BAR
   ============================================= */
(function () {
  function initStickyATCBar() {
    const stickyBar     = document.getElementById('sticky-atc-bar');
    const stickyBtn     = document.getElementById('sticky-atc-btn');
    const stickyQtyMinus = document.querySelector('.sticky-qty-minus');
    const stickyQtyPlus  = document.querySelector('.sticky-qty-plus');
    const stickyQtyInput = document.querySelector('.sticky-qty-input');
    const stickyPrice    = document.getElementById('sticky-atc-price');

    if (!stickyBar || !stickyBtn) return;

    // ---- 1. SHOW / HIDE via IntersectionObserver ----
    // Track visibility of main ATC button and footer independently
    let atcOutOfView  = false; // true when main button has scrolled past
    let footerInView  = false; // true when footer is visible
    let initialCheckDone = false; // first observer fire = page load state

    function updateStickyBarVisibility() {
      if (atcOutOfView && !footerInView) {
        // On initial load: appear instantly (no slide animation)
        if (!initialCheckDone) {
          stickyBar.style.transition = 'none';
        }
        stickyBar.classList.add('sticky-atc-visible');
        stickyBar.setAttribute('aria-hidden', 'false');
        // Re-enable transition after first paint so future scroll triggers animate smoothly
        if (!initialCheckDone) {
          initialCheckDone = true;
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              stickyBar.style.transition = '';
            });
          });
        }
      } else {
        initialCheckDone = true; // button was visible on load — mark done
        stickyBar.classList.remove('sticky-atc-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      }
    }

    // Observe main ATC button
    const mainAtcBtn = document.querySelector('.snippet-addto-cart .product-addcart');
    if (mainAtcBtn) {
      const atcObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            atcOutOfView = !entry.isIntersecting;
            updateStickyBarVisibility();
          });
        },
        { threshold: 0, rootMargin: '0px' }
      );
      atcObserver.observe(mainAtcBtn);
    }

    // Observe footer — hide sticky bar when footer comes into view
    // Theme footer uses <footer class="section-footer ...">
    const footerEl = document.querySelector('footer.section-footer');
    if (footerEl) {
      const footerObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            footerInView = entry.isIntersecting;
            updateStickyBarVisibility();
          });
        },
        { threshold: 0, rootMargin: '0px' }
      );
      footerObserver.observe(footerEl);
    }

    // ---- 2. QUANTITY SYNC (sticky ↔ main) ----
    const mainQtyInput   = document.querySelector('.snippet-addto-cart .qty-input:not(.sticky-qty-input)');
    const mainQtyMinus   = document.querySelector('.snippet-addto-cart .qty-minus');
    const mainQtyPlus    = document.querySelector('.snippet-addto-cart .qty-plus');

    function syncMainToSticky(val) {
      if (stickyQtyInput) stickyQtyInput.value = val;
      // Update sticky minus disabled state
      if (stickyQtyMinus) {
        if (parseInt(val) <= 1) {
          stickyQtyMinus.classList.add('disabled');
          stickyQtyMinus.setAttribute('disabled', 'disabled');
        } else {
          stickyQtyMinus.classList.remove('disabled');
          stickyQtyMinus.removeAttribute('disabled');
        }
      }
    }

    function syncStickyToMain(val) {
      if (mainQtyInput) {
        mainQtyInput.value = val;
        mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const hiddenQty = document.querySelector('.snippet-addto-cart form .hidden-quantity');
      if (hiddenQty) {
        hiddenQty.value = val;
        hiddenQty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      
      // After any change, wait 1s and sync price from app element
      setTimeout(function() {
        const appPriceEl = document.querySelector('.mw-apo-price-custom .mw-text.mw-text--style-strong');
        if (appPriceEl && stickyPrice) {
          syncAppPrice(appPriceEl);
        }
      }, 1000);
    }

    // Sticky minus button
    if (stickyQtyMinus) {
      stickyQtyMinus.addEventListener('click', function (e) {
        e.preventDefault();
        let cur = parseInt(stickyQtyInput.value) || 1;
        if (cur > 1) {
          cur--;
          stickyQtyInput.value = cur;
          syncStickyToMain(cur);
          syncMainToSticky(cur);
          updateTotalPrice(cur);
        }
      });
    }

    // Sticky plus button
    if (stickyQtyPlus) {
      stickyQtyPlus.addEventListener('click', function (e) {
        e.preventDefault();
        let cur = parseInt(stickyQtyInput.value) || 1;
        cur++;
        stickyQtyInput.value = cur;
        syncStickyToMain(cur);
        syncMainToSticky(cur);
        updateTotalPrice(cur);
      });
    }
    // Sticky input manual change
    if (stickyQtyInput) {
      stickyQtyInput.addEventListener('change', function () {
        syncStickyToMain(this.value);
      });
    }
    // When main qty changes (e.g., user changes via main selector), mirror to sticky
    if (mainQtyInput) {
      mainQtyInput.addEventListener('change', function () {
        syncMainToSticky(this.value);
      });
      // Also listen for click-driven changes via qty buttons on main
      if (mainQtyMinus) {
        mainQtyMinus.addEventListener('click', function () {
          setTimeout(function () {
            syncMainToSticky(mainQtyInput.value);
          }, 60);
        });
      }
      if (mainQtyPlus) {
        mainQtyPlus.addEventListener('click', function () {
          setTimeout(function () {
            syncMainToSticky(mainQtyInput.value);
          }, 60);
        });
      }
    }

    // ---- 3. PRICE SYNC when variant / app options change ----

    // Helper: copy app price el HTML → sticky price
    function syncAppPrice(appPriceEl) {
      if (stickyPrice && appPriceEl) {
        const innerDiv = appPriceEl.querySelector('div');
        stickyPrice.innerHTML = innerDiv ? innerDiv.innerHTML : appPriceEl.innerHTML;
      }
    }

    // Priority 1: Shopify app price element (.mw-apo-price-custom .mw-text.mw-text--style-strong)
    // Only activate when this element exists on the page
    const appPriceEl = document.querySelector('.mw-apo-price-custom .mw-text.mw-text--style-strong');
    if (appPriceEl && stickyPrice) {
      // Set initial value immediately
      syncAppPrice(appPriceEl);

      // Watch for any future updates from the app
      const appPriceObserver = new MutationObserver(function () {
        syncAppPrice(appPriceEl);
      });
      appPriceObserver.observe(appPriceEl, { childList: true, characterData: true, subtree: true });

    } else {
      // Fallback: watch the theme's own price elements
      const mainPriceEl = document.querySelector('.price-regular.product-price');
      if (mainPriceEl && stickyPrice) {
        const priceObserver = new MutationObserver(function () {
          stickyPrice.textContent = mainPriceEl.textContent.trim();
        });
        priceObserver.observe(mainPriceEl, { childList: true, characterData: true, subtree: true });
      }

      const totalPriceEl = document.querySelector('.total-price-value');
      if (totalPriceEl && stickyPrice) {
        const totalObserver = new MutationObserver(function () {
          stickyPrice.textContent = totalPriceEl.textContent.trim();
        });
        totalObserver.observe(totalPriceEl, { childList: true, characterData: true, subtree: true });
      }
    }

    // ---- 4. STICKY ATC BUTTON CLICK ----
    stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();

      // Sync sticky qty → main qty inputs before triggering
      const qty = parseInt(stickyQtyInput ? stickyQtyInput.value : 1) || 1;
      if (mainQtyInput) {
        mainQtyInput.value = qty;
        mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const hiddenQty = document.querySelector('.snippet-addto-cart form .hidden-quantity');
      if (hiddenQty) hiddenQty.value = qty;

      // Trigger click on the main ATC button — handles all app logic, cart, etc.
      const mainBtn = document.querySelector('.snippet-addto-cart .product-addcart');
      if (mainBtn) {
        mainBtn.click();
      }
    });

    // ---- 5. VARIANT CHANGE: update sticky button disabled state ----
    // Listen for changes to the main ATC button's disabled attr
    const mainFormBtn = document.querySelector('.snippet-addto-cart [name="add"]');
    if (mainFormBtn) {
      const btnObserver = new MutationObserver(function () {
        if (mainFormBtn.hasAttribute('disabled')) {
          stickyBtn.setAttribute('disabled', 'disabled');
        } else {
          stickyBtn.removeAttribute('disabled');
        }
        // Also update button text
        const mainBtnSpan = mainFormBtn.querySelector('span');
        const stickyBtnSpan = stickyBtn.querySelector('span');
        if (mainBtnSpan && stickyBtnSpan) {
          stickyBtnSpan.textContent = mainBtnSpan.textContent.trim();
        }
      });
      btnObserver.observe(mainFormBtn, { attributes: true, childList: true, subtree: true });
    }
  }

  // Function to remove all slick-related classes, attributes, and styles
  function removeSlickTraces() {
    const slickElements = document.querySelectorAll('[class*="slick-"], [data-slick-index], [data-carousel-mode]');
    slickElements.forEach(el => {
      // Remove classes that start with slick-
      if (el.className && typeof el.className === 'string') {
        const classes = el.className.split(' ').filter(c => !c.startsWith('slick-'));
        el.className = classes.join(' ').trim();
      }
      
      // Remove slick/carousel related data attributes
      for (let key in el.dataset) {
        if (key.toLowerCase().includes('slick') || key.toLowerCase().includes('carousel')) {
          delete el.dataset[key];
        }
      }
      
      // Remove potential slick-injected inline styles
      if (el.style.width === '0px') el.style.width = '';
      if (el.style.opacity === '0') el.style.opacity = '';
      if (el.style.transform && el.style.transform.includes('translate3d')) el.style.transform = '';
    });
  }

  // Init on DOMContentLoaded and on Shopify section reload
  // 1s delay so app-injected buttons and scripts have time to render
  function initStickyATCBarDelayed() {
    setTimeout(() => {
      initStickyATCBar();
      removeSlickTraces();
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyATCBarDelayed);
  } else {
    initStickyATCBarDelayed();
  }

  document.addEventListener('shopify:section:load', initStickyATCBarDelayed);
})();



// class VariantRadios extends HTMLElement {
//   constructor() {
//     super();
//     this.addEventListener('change', this.onVariantChange);    
//   }
//   onVariantChange() {
//     this.updateOptions();
//     this.updateMasterId();
//     this.toggleAddButton(true, '', false);
//     if (!this.currentVariant){
//       this.toggleAddButton(true, '', true);
//       this.setUnavailable();
//     }else {
//       this.updateMedia();
//       this.updateVariantInput();
//       this.updateURL();
//       this.renderProductInfo();
//       this.updatePriceDisplay();
//     }
//   }
//   updateMasterId() {
//     this.currentVariant = this.getVariantData().find((variant) => {
//       return !variant.options.map((option, index) => {
//         return this.options[index] === option;
//       }).includes(false);
//     });
//   }
//   updateMedia() {
//     if (!this.currentVariant) return;
//     if (!this.currentVariant.featured_media) return;
//     var fetured_id = this.currentVariant.featured_media.id;
//     if(document.querySelector('.media-thumb')){
//       document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
//         var mediaid = e.dataset.id;
//         if(mediaid==fetured_id){
//           new Swiper('.media-nav').slideTo(e.dataset.index,1000,false);
//         }
//       });
//     }
//   }
//   updateURL() {
//     if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
//     window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
//   }
//   updateVariantInput() {
//     const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
//     productForms.forEach((productForm) => {
//       const input = productForm.querySelector('input[name="id"]');
//       input.value = this.currentVariant.id;
//       input.dispatchEvent(new Event('change', { bubbles: true }));
//     });
//   }
//   updateOptions() {
//     const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
//     const fieldlen = fieldsets.length;
//     let option_count = 0;
//     fieldsets.forEach(function(eachfield){
//       var checked_gender = eachfield.querySelector('input:checked');
//       if(checked_gender){
//         option_count++;
//       }
//     });
//     this.options = fieldsets.map((fieldset) => {
//       if(option_count>=fieldlen){
//         return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
//       }
//     });
//     if(option_count>=fieldlen){
//       document.querySelector('.choose-cart').classList.remove('hide-selectore-button');
//       document.querySelector('.choose-selector').classList.add('hide-selectore-button');      
//     }else{
//       document.querySelector('.choose-cart').classList.add('hide-selectore-button');
//       document.querySelector('.choose-selector').classList.remove('hide-selectore-button');
//     }   
//   }
//   updatePriceDisplay() {
//     if (!this.currentVariant) return;
//     const priceElement = document.querySelector('.total-price-value');
//     if (priceElement && this.currentVariant.price) {
//       const unitPrice = this.currentVariant.price / 100;
//       priceElement.setAttribute('data-unit-price', unitPrice);
//       const qtyInput = document.querySelector('.qty-input');
//       const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
//       updateTotalPrice(quantity);
//     }
//   }
//   renderProductInfo() {
//     fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
//     .then((response) => response.text())
//     .then((responseText) => {
//       const id = `price-${this.dataset.section}`;
//       const html = new DOMParser().parseFromString(responseText, 'text/html')
//       const destination = document.getElementById(id);
//       const source = html.getElementById(id);
//       if (source && destination) destination.innerHTML = source.innerHTML;
//       if(this.currentVariant){
//         this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
//       }
//     });
//   }
//   toggleAddButton(disable = true, text, modifyClass = true) {
//     const productForm = document.getElementById(`product-form-${this.dataset.section}`);
//     if (!productForm) return;
//     const addButton = productForm.querySelector('[name="add"]');
//     const addButtonText = productForm.querySelector('[name="add"] > span');
//     if (!addButton) return;
//     if (disable) {
//       addButton.setAttribute('disabled', 'disabled');
//       if (text) addButtonText.textContent = text;
//     } else {
//       addButton.removeAttribute('disabled');
//       addButtonText.textContent = window.variantStrings.addToCart;
//     }
//     if (!modifyClass) return;
//   }
//   setUnavailable() {
//     const button = document.getElementById(`product-form-${this.dataset.section}`);
//     const addButton = button.querySelector('[name="add"]');
//     const addButtonText = button.querySelector('[name="add"] > span');
//     const price = document.getElementById(`price-${this.dataset.section}`);
//     if (!addButton) return;
//     addButtonText.textContent = window.variantStrings.unavailable;
//   }
//   getVariantData() {
//     this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
//     return this.variantData;
//   }
// }
// customElements.define('variant-radios', VariantRadios);

// // Function to format price with currency
// function formatMoney(cents, format) {
//   if (typeof cents === 'string') {
//     cents = cents.replace('.', '');
//   }
//   let value = '';
//   const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
//   const formatString = format || '${{amount}}';

//   function formatWithDelimiters(number, precision, thousands, decimal) {
//     thousands = thousands || ',';
//     decimal = decimal || '.';

//     if (isNaN(number) || number === null) {
//       return '0';
//     }

//     number = (number / 100.0).toFixed(precision);

//     const parts = number.split('.');
//     const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
//     const centsAmount = parts[1] ? decimal + parts[1] : '';

//     return dollarsAmount + centsAmount;
//   }

//   switch (formatString.match(placeholderRegex)[1]) {
//     case 'amount':
//       value = formatWithDelimiters(cents, 2);
//       break;
//     case 'amount_no_decimals':
//       value = formatWithDelimiters(cents, 0);
//       break;
//     case 'amount_with_comma_separator':
//       value = formatWithDelimiters(cents, 2, '.', ',');
//       break;
//     case 'amount_no_decimals_with_comma_separator':
//       value = formatWithDelimiters(cents, 0, '.', ',');
//       break;
//     case 'amount_no_decimals_with_space_separator':
//       value = formatWithDelimiters(cents, 0, ' ');
//       break;
//     case 'amount_with_apostrophe_separator':
//       value = formatWithDelimiters(cents, 2, "'");
//       break;
//   }

//   return formatString.replace(placeholderRegex, value);
// }

// // Function to update total price
// function updateTotalPrice(quantity) {
//   const priceElement = document.querySelector('.total-price-value');
//   if (!priceElement) return;

//   const unitPrice = parseFloat(priceElement.getAttribute('data-unit-price'));
//   if (isNaN(unitPrice)) return;

//   const totalPrice = unitPrice * quantity;
//   const totalPriceInCents = Math.round(totalPrice * 100);
  
//   // Get the currency format from Shopify theme settings
//   const moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}';
  
//   priceElement.textContent = formatMoney(totalPriceInCents, moneyFormat);
// }

// // Quantity Selector Functionality with Hidden Input Sync and Price Update
// function initQuantitySelector() {
//   const quantitySelectors = document.querySelectorAll('.quantity-selector');
  
//   quantitySelectors.forEach(selector => {
//     const minusBtn = selector.querySelector('.qty-minus');
//     const plusBtn = selector.querySelector('.qty-plus');
//     const input = selector.querySelector('.qty-input');
    
//     // Find the hidden quantity input in the form
//     const form = selector.closest('.snippet-addto-cart').querySelector('form');
//     const hiddenQuantity = form ? form.querySelector('.hidden-quantity') : null;
    
//     if (minusBtn && plusBtn && input) {
//       // Remove any existing listeners by cloning
//       const newMinusBtn = minusBtn.cloneNode(true);
//       const newPlusBtn = plusBtn.cloneNode(true);
//       minusBtn.parentNode.replaceChild(newMinusBtn, minusBtn);
//       plusBtn.parentNode.replaceChild(newPlusBtn, plusBtn);
      
//       // Function to sync hidden input, update price, and toggle minus button state
//       const syncQuantity = (value) => {
//         if (hiddenQuantity) {
//           hiddenQuantity.value = value;
//         }
//         updateTotalPrice(value);
        
//         // Toggle disabled class on minus button
//         if (value <= 1) {
//           newMinusBtn.classList.add('disabled');
//           newMinusBtn.setAttribute('disabled', 'disabled');
//         } else {
//           newMinusBtn.classList.remove('disabled');
//           newMinusBtn.removeAttribute('disabled');
//         }
//       };
      
//       // Minus button click
//       newMinusBtn.addEventListener('click', function(e) {
//         e.preventDefault();
//         let currentValue = parseInt(input.value) || 1;
//         if (currentValue > 1) {
//           currentValue = currentValue - 1;
//           input.value = currentValue;
//           syncQuantity(currentValue);
//           input.dispatchEvent(new Event('change', { bubbles: true }));
//         }
//       });
      
//       // Plus button click
//       newPlusBtn.addEventListener('click', function(e) {
//         e.preventDefault();
//         let currentValue = parseInt(input.value) || 1;
//         currentValue = currentValue + 1;
//         input.value = currentValue;
//         syncQuantity(currentValue);
//         input.dispatchEvent(new Event('change', { bubbles: true }));
//       });
      
//       // Input change validation and sync
//       input.addEventListener('input', function() {
//         let value = parseInt(this.value) || 1;
//         if (value < 1) {
//           value = 1;
//           this.value = value;
//         }
//         syncQuantity(value);
//       });
      
//       input.addEventListener('blur', function() {
//         let value = parseInt(this.value) || 1;
//         if (this.value === '' || value < 1) {
//           value = 1;
//           this.value = value;
//         }
//         syncQuantity(value);
//       });
      
//       // Initialize hidden input and price with current value
//       const initialValue = parseInt(input.value) || 1;
//       syncQuantity(initialValue);
//     }
//   });
// }

// function variant_drodown(){
//   if(document.querySelector('.dropdown-wrap')){
//     document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
//       dropdown.querySelector('.variant-dropdown').addEventListener('click',function(event){
//         event.preventDefault();
        
//         // Check if currently active
//         const isActive = dropdown.classList.contains('active');
        
//         // Close all dropdowns
//         document.querySelectorAll('.dropdown-wrap').forEach(function(d){
//           d.classList.remove('active');
//         });
        
//         // If it wasn't active, open it
//         if (!isActive) {
//           dropdown.classList.add('active');
//         }
//       });
      
//       // Attach change event listener safely outside of click
//       dropdown.querySelectorAll('input[type="radio"]').forEach(function(e){
//         e.addEventListener('change',function(button){
//           dropdown.classList.remove('active');
//           dropdown.querySelector('.variant-dropdown').innerHTML = e.value;
//         });
//       });
//     });

//     // Close dropdowns if user clicks outside of them
//     document.addEventListener('click', function(event) {
//       if (!event.target.closest('.dropdown-wrap')) {
//         document.querySelectorAll('.dropdown-wrap').forEach(function(d){
//           d.classList.remove('active');
//         });
//       }
//     });
//   }
// }

// // Add to Cart functionality
// const _productAddcartBtn = document.querySelector('.product-addcart');
// if (_productAddcartBtn) _productAddcartBtn.addEventListener('click',function(evt){
//   evt.preventDefault();
//   const config = fetchConfig('javascript');
//   config.headers['X-Requested-With'] = 'XMLHttpRequest';
//   delete config.headers['Content-Type'];
//   var cartform = document.querySelector('.product-addcart').closest('form');
//   const formData = new FormData(cartform);  
//   config.body = formData;
//   fetch(`${routes.cart_add_url}`, config)
//   .then((response) => response.json())
//   .then((response) => {
//     if (response.status) {
//       document.querySelector('.product-form-error').innerHTML = response.description;
//       setTimeout(function(e){
//         document.querySelector('.product-form-error').innerHTML  = '';
//       },2000);
//       return;
//     }else{
//       if(typeof load_cart == 'function'){
//         load_cart();
//         setTimeout(function(e){
//           document.querySelector('body').classList.add('open-drawer');
//         },500);
//       }else{
//         window.location.href = "/cart";
//       }
//     }
//   })
//   .catch((e) => {
//     console.error(e);
//   })
//   .finally(() => {

//   });
// });

// // Buy Now functionality - NEW CODE
// function initBuyNowButton() {
//   const buyNowButtons = document.querySelectorAll('.buy-now-button');
  
//   buyNowButtons.forEach(button => {
//     // Remove any existing listeners by cloning
//     const newButton = button.cloneNode(true);
//     button.parentNode.replaceChild(newButton, button);
    
//     newButton.addEventListener('click', function(e) {
//       e.preventDefault();
      
//       // Find the closest form
//       const form = this.closest('.snippet-addto-cart').querySelector('form');
//       if (!form) {
//         console.error('Form not found');
//         return;
//       }
      
//       // Get variant ID
//       const variantIdInput = form.querySelector('input[name="id"]');
//       const variantId = variantIdInput ? variantIdInput.value : null;
      
//       // Get quantity from the visible input
//       const qtyInput = document.querySelector('.qty-input');
//       const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      
//       if (!variantId) {
//         // Show error if no variant selected
//         const errorElement = document.querySelector('.product-form-error');
//         if (errorElement) {
//           errorElement.innerHTML = 'Please select a variant';
//           setTimeout(function() {
//             errorElement.innerHTML = '';
//           }, 2000);
//         }
//         return;
//       }
      
//       // Disable button to prevent double clicks
//       newButton.disabled = true;
//       newButton.style.opacity = '0.6';
      
//       // Prepare form data
//       const formData = {
//         items: [{
//           id: variantId,
//           quantity: quantity
//         }]
//       };
      
//       // Add to cart and redirect to checkout
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData)
//       })
//       .then(response => response.json())
//       .then(data => {
//         if (data.status && data.status === 422) {
//           // Handle error
//           const errorElement = document.querySelector('.product-form-error');
//           if (errorElement) {
//             errorElement.innerHTML = data.description || 'Error adding to cart';
//             setTimeout(function() {
//               errorElement.innerHTML = '';
//             }, 2000);
//           }
//           // Re-enable button
//           newButton.disabled = false;
//           newButton.style.opacity = '1';
//         } else {
//           // Success - redirect to checkout
//           load_cart();
//           window.location.href = '/checkout';
//         }
//       })
//       .catch(error => {
//         console.error('Error:', error);
//         const errorElement = document.querySelector('.product-form-error');
//         if (errorElement) {
//           errorElement.innerHTML = 'There was an error. Please try again.';
//           setTimeout(function() {
//             errorElement.innerHTML = '';
//           }, 2000);
//         }
//         // Re-enable button
//         newButton.disabled = false;
//         newButton.style.opacity = '1';
//       });
//     });
//   });
// }

// function fetchConfig(type = 'json') {
//   return {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
//   };
// }

// function initProductMediaSlider() {
//   if (!document.querySelector('.product-media-gallery')) return;
  
//   // Initialize thumbnail slider first
//   const thumbnailSlider = new Swiper(".thumbnail-media-slider", {
//     loop: false,
//     spaceBetween: 20,
//     slidesPerView: 5,
//     direction: 'vertical',
//     freeMode: false,
//     mousewheel: true,
//     watchSlidesProgress: true,
//     slideToClickedSlide: true,
//     // centeredSlides: false,
//     // slidesPerGroup: 1,
//     breakpoints: {
//       0: {
//         direction: 'horizontal',
//         slidesPerView: 4,
//       },
//       768: {
//         direction: 'vertical',
//         slidesPerView: 5,
//       }
//     }
//   });

//   // Initialize main media slider
//   const mainMediaSlider = new Swiper(".main-media-slider", {
//     loop: false,
//     spaceBetween: 10,
//     navigation: {
//       nextEl: ".slider-nav-next",
//       prevEl: ".slider-nav-prev",
//     },
//     pagination: {
//       el: ".slider-dots",
//       clickable: true,
//     },
//     thumbs: {
//       swiper: thumbnailSlider,
//     },
//   });

//   // When main slider changes, scroll thumbnails smartly
//   mainMediaSlider.on('slideChange', function() {
//     const activeIndex = mainMediaSlider.activeIndex;
//     const totalSlides = mainMediaSlider.slides.length;
//     const visibleSlides = 5;
    
//     // Calculate which thumbnail should be at the top
//     if (activeIndex >= visibleSlides - 1) {
//       // Scroll so the active slide is at the bottom of visible area
//       thumbnailSlider.slideTo(activeIndex - visibleSlides + 1);
//     } else {
//       // Keep at the beginning
//       thumbnailSlider.slideTo(0);
//     }
//   });
// }

// // Initialize on DOM ready
// if (document.readyState === 'loading') {
//   document.addEventListener('DOMContentLoaded', function() {
//     // initProductMediaSlider();
//     initQuantitySelector();
//     initBuyNowButton(); // Initialize Buy Now button
//   });
// } else {
//   // initProductMediaSlider();
//   initQuantitySelector();
//   initBuyNowButton(); // Initialize Buy Now button
// }

// // initProductMediaSlider();
// initQuantitySelector();
// initBuyNowButton(); // Initialize Buy Now button
// variant_drodown();

// document.addEventListener("shopify:section:load", function(event) {
//   // initProductMediaSlider();
//   initQuantitySelector();
//   initBuyNowButton(); // Initialize Buy Now button on section reload
//   variant_drodown();
// });

// function getElementY(query) {
//   return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
// }

// function doScrolling(element, duration) {
//   var startingY = window.pageYOffset
//   var elementY = getElementY(element)
//   var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
//   var diff = targetY - startingY
//   var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
//   var start
//   if (!diff) return
//   window.requestAnimationFrame(function step(timestamp) {
//     if (!start) start = timestamp
//     var time = timestamp - start
//     var percent = Math.min(time / duration, 1)
//     percent = easing(percent)
//     window.scrollTo(0, startingY + diff * percent)
//     if (time < duration) {
//       window.requestAnimationFrame(step)
//     }
//   })
// }

// if(document.querySelector('.choose-selector')){
//   if (window.innerWidth < 641) {
//     document.querySelector('.choose-selector a').addEventListener('click', doScrolling.bind(null, '#product-form-installment', 2000))
//   }
// }

// const shareBtn = document.querySelector('#get-share');

// if (shareBtn) shareBtn.addEventListener('click', async () => {
//   try {
//     const urlToCopy = window.location.href;
//     await navigator.clipboard.writeText(urlToCopy);
//     shareBtn.classList.add('copied');
//     shareBtn.querySelector('p').textContent = 'Link Copied!';
//     setTimeout(() => {
//       shareBtn.classList.remove('copied');
//       shareBtn.querySelector('p').textContent = shareBtn.dataset.text;
//     }, 2000);

//   } catch (err) {
//     console.error('Failed to copy:', err);
//   }
// });

// /* =============================================
//    STICKY ADD-TO-CART BAR
//    ============================================= */
// (function () {
//   function initStickyATCBar() {
//     const stickyBar     = document.getElementById('sticky-atc-bar');
//     const stickyBtn     = document.getElementById('sticky-atc-btn');
//     const stickyQtyMinus = document.querySelector('.sticky-qty-minus');
//     const stickyQtyPlus  = document.querySelector('.sticky-qty-plus');
//     const stickyQtyInput = document.querySelector('.sticky-qty-input');
//     const stickyPrice    = document.getElementById('sticky-atc-price');

//     if (!stickyBar || !stickyBtn) return;

//     // ---- 1. SHOW / HIDE via IntersectionObserver ----
//     // Track visibility of main ATC button and footer independently
//     let atcOutOfView  = false; // true when main button has scrolled past
//     let footerInView  = false; // true when footer is visible
//     let initialCheckDone = false; // first observer fire = page load state

//     function updateStickyBarVisibility() {
//       if (atcOutOfView && !footerInView) {
//         // On initial load: appear instantly (no slide animation)
//         if (!initialCheckDone) {
//           stickyBar.style.transition = 'none';
//         }
//         stickyBar.classList.add('sticky-atc-visible');
//         stickyBar.setAttribute('aria-hidden', 'false');
//         // Re-enable transition after first paint so future scroll triggers animate smoothly
//         if (!initialCheckDone) {
//           initialCheckDone = true;
//           requestAnimationFrame(function () {
//             requestAnimationFrame(function () {
//               stickyBar.style.transition = '';
//             });
//           });
//         }
//       } else {
//         initialCheckDone = true; // button was visible on load — mark done
//         stickyBar.classList.remove('sticky-atc-visible');
//         stickyBar.setAttribute('aria-hidden', 'true');
//       }
//     }

//     // Observe main ATC button
//     const mainAtcBtn = document.querySelector('.snippet-addto-cart .product-addcart');
//     if (mainAtcBtn) {
//       const atcObserver = new IntersectionObserver(
//         function (entries) {
//           entries.forEach(function (entry) {
//             atcOutOfView = !entry.isIntersecting;
//             updateStickyBarVisibility();
//           });
//         },
//         { threshold: 0, rootMargin: '0px' }
//       );
//       atcObserver.observe(mainAtcBtn);
//     }

//     // Observe footer — hide sticky bar when footer comes into view
//     // Theme footer uses <footer class="section-footer ...">
//     const footerEl = document.querySelector('footer.section-footer');
//     if (footerEl) {
//       const footerObserver = new IntersectionObserver(
//         function (entries) {
//           entries.forEach(function (entry) {
//             footerInView = entry.isIntersecting;
//             updateStickyBarVisibility();
//           });
//         },
//         { threshold: 0, rootMargin: '0px' }
//       );
//       footerObserver.observe(footerEl);
//     }

//     // ---- 2. QUANTITY SYNC (sticky ↔ main) ----
//     const mainQtyInput   = document.querySelector('.snippet-addto-cart .qty-input:not(.sticky-qty-input)');
//     const mainQtyMinus   = document.querySelector('.snippet-addto-cart .qty-minus');
//     const mainQtyPlus    = document.querySelector('.snippet-addto-cart .qty-plus');

//     function syncMainToSticky(val) {
//       if (stickyQtyInput) stickyQtyInput.value = val;
//       // Update sticky minus disabled state
//       if (stickyQtyMinus) {
//         if (parseInt(val) <= 1) {
//           stickyQtyMinus.classList.add('disabled');
//           stickyQtyMinus.setAttribute('disabled', 'disabled');
//         } else {
//           stickyQtyMinus.classList.remove('disabled');
//           stickyQtyMinus.removeAttribute('disabled');
//         }
//       }
//     }

//     function syncStickyToMain(val) {
//       if (mainQtyInput) {
//         mainQtyInput.value = val;
//         mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
//       }
//     }

//     // Sticky minus button
//     if (stickyQtyMinus) {
//       stickyQtyMinus.addEventListener('click', function (e) {
//         e.preventDefault();
//         let cur = parseInt(stickyQtyInput.value) || 1;
//         if (cur > 1) {
//           cur--;
//           stickyQtyInput.value = cur;
//           syncStickyToMain(cur);
//           syncMainToSticky(cur);
//           updateTotalPrice(cur);
//         }
//       });
//     }

//     // Sticky plus button
//     if (stickyQtyPlus) {
//       stickyQtyPlus.addEventListener('click', function (e) {
//         e.preventDefault();
//         let cur = parseInt(stickyQtyInput.value) || 1;
//         cur++;
//         stickyQtyInput.value = cur;
//         syncStickyToMain(cur);
//         syncMainToSticky(cur);
//         updateTotalPrice(cur);
//       });
//     }

//     // When main qty changes (e.g., user changes via main selector), mirror to sticky
//     if (mainQtyInput) {
//       mainQtyInput.addEventListener('change', function () {
//         syncMainToSticky(this.value);
//       });
//       // Also listen for click-driven changes via qty buttons on main
//       if (mainQtyMinus) {
//         mainQtyMinus.addEventListener('click', function () {
//           setTimeout(function () {
//             syncMainToSticky(mainQtyInput.value);
//           }, 60);
//         });
//       }
//       if (mainQtyPlus) {
//         mainQtyPlus.addEventListener('click', function () {
//           setTimeout(function () {
//             syncMainToSticky(mainQtyInput.value);
//           }, 60);
//         });
//       }
//     }

//     // ---- 3. PRICE SYNC when variant / app options change ----

//     // Helper: copy app price el HTML → sticky price
//     function syncAppPrice(appPriceEl) {
//       if (stickyPrice && appPriceEl) {
//         const innerDiv = appPriceEl.querySelector('div');
//         stickyPrice.innerHTML = innerDiv ? innerDiv.innerHTML : appPriceEl.innerHTML;
//       }
//     }

//     // Priority 1: Shopify app price element (.mw-apo-price-custom .mw-text.mw-text--style-strong)
//     // Only activate when this element exists on the page
//     const appPriceEl = document.querySelector('.mw-apo-price-custom .mw-text.mw-text--style-strong');
//     if (appPriceEl && stickyPrice) {
//       // Set initial value immediately
//       syncAppPrice(appPriceEl);

//       // Watch for any future updates from the app
//       const appPriceObserver = new MutationObserver(function () {
//         syncAppPrice(appPriceEl);
//       });
//       appPriceObserver.observe(appPriceEl, { childList: true, characterData: true, subtree: true });

//     } else {
//       // Fallback: watch the theme's own price elements
//       const mainPriceEl = document.querySelector('.price-regular.product-price');
//       if (mainPriceEl && stickyPrice) {
//         const priceObserver = new MutationObserver(function () {
//           stickyPrice.textContent = mainPriceEl.textContent.trim();
//         });
//         priceObserver.observe(mainPriceEl, { childList: true, characterData: true, subtree: true });
//       }

//       const totalPriceEl = document.querySelector('.total-price-value');
//       if (totalPriceEl && stickyPrice) {
//         const totalObserver = new MutationObserver(function () {
//           stickyPrice.textContent = totalPriceEl.textContent.trim();
//         });
//         totalObserver.observe(totalPriceEl, { childList: true, characterData: true, subtree: true });
//       }
//     }

//     // ---- 4. STICKY ATC BUTTON CLICK ----
//     stickyBtn.addEventListener('click', function (e) {
//       e.preventDefault();

//       // Sync sticky qty → main qty inputs before triggering
//       const qty = parseInt(stickyQtyInput ? stickyQtyInput.value : 1) || 1;
//       if (mainQtyInput) {
//         mainQtyInput.value = qty;
//         mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
//       }
//       const hiddenQty = document.querySelector('.snippet-addto-cart form .hidden-quantity');
//       if (hiddenQty) hiddenQty.value = qty;

//       // Trigger click on the main ATC button — handles all app logic, cart, etc.
//       const mainBtn = document.querySelector('.snippet-addto-cart .product-addcart');
//       if (mainBtn) {
//         mainBtn.click();
//       }
//     });

//     // ---- 5. VARIANT CHANGE: update sticky button disabled state ----
//     // Listen for changes to the main ATC button's disabled attr
//     const mainFormBtn = document.querySelector('.snippet-addto-cart [name="add"]');
//     if (mainFormBtn) {
//       const btnObserver = new MutationObserver(function () {
//         if (mainFormBtn.hasAttribute('disabled')) {
//           stickyBtn.setAttribute('disabled', 'disabled');
//         } else {
//           stickyBtn.removeAttribute('disabled');
//         }
//         // Also update button text
//         const mainBtnSpan = mainFormBtn.querySelector('span');
//         const stickyBtnSpan = stickyBtn.querySelector('span');
//         if (mainBtnSpan && stickyBtnSpan) {
//           stickyBtnSpan.textContent = mainBtnSpan.textContent.trim();
//         }
//       });
//       btnObserver.observe(mainFormBtn, { attributes: true, childList: true, subtree: true });
//     }
//   }


//   // Function to remove all slick-related classes, attributes, and styles
//   function removeSlickTraces() {
//     const slickElements = document.querySelectorAll('.tab-content.content-tab [class*="slick-"], .tab-content.content-tab [data-slick-index], .tab-content.content-tab [data-carousel-mode]');
//     slickElements.forEach(el => {
//       // Remove classes that start with slick-
//       if (el.className && typeof el.className === 'string') {
//         const classes = el.className.split(' ').filter(c => !c.startsWith('slick-'));
//         el.className = classes.join(' ').trim();
//       }
      
//       // Remove slick/carousel related data attributes
//       for (let key in el.dataset) {
//         if (key.toLowerCase().includes('slick') || key.toLowerCase().includes('carousel')) {
//           delete el.dataset[key];
//         }
//       }
      
//       // Remove potential slick-injected inline styles
//       if (el.style.width === '0px') el.style.width = '';
//       if (el.style.opacity === '0') el.style.opacity = '';
//       if (el.style.transform && el.style.transform.includes('translate3d')) el.style.transform = '';
//     });
//   }

//   // Init on DOMContentLoaded and on Shopify section reload
//   // 1s delay so app-injected buttons have time to render before we query them
//   function initStickyATCBarDelayed() {
//     setTimeout(initStickyATCBar, 1000);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', initStickyATCBarDelayed);
//   } else {
//     initStickyATCBarDelayed();
//   }

//   document.addEventListener('shopify:section:load', initStickyATCBarDelayed);
// })();


